// src/components/Collections.js
import React, { useState } from "react";
import { Card, Image, Skeleton, Empty, Row, Col, Tag, Divider } from "antd";
import { useCollections } from "./useCollections";
import { LockOutlined, GlobalOutlined, PictureOutlined } from "@ant-design/icons";

const { Meta } = Card;

const CollectionThumbnail = ({ image }) => {
  const [failed, setFailed] = useState(!image.file_url);

  if (failed) {
    return (
      <div
        style={{
          height: 80,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f5f5",
        }}
      >
        <PictureOutlined style={{ fontSize: 28, color: "#8c8c8c" }} />
      </div>
    );
  }

  return (
    <Image
      src={image.file_url}
      alt={image.title}
      height={80}
      style={{ objectFit: "cover", marginBottom: "8px" }}
      onError={() => setFailed(true)}
      preview={{
        mask: (
          <div style={{ textAlign: "center" }}>Click to Preview</div>
        ),
        maskStyle: { fontSize: "10px" },
      }}
    />
  );
};

const Collections = () => {
  const { data, isLoading, isError } = useCollections();

  if (isLoading) {
    return <Skeleton active />;
  }

  if (isError) {
    return <Empty description="Failed to load collections" />;
  }

  if (!data || data.length === 0) {
    return <Empty description="No collections available" />;
  }

  return (
    <Row gutter={[16, 16]}>
      {data.map((collection) => (
        <Col key={collection.id} xs={24} sm={24} md={8}>
          <Card
            hoverable
            style={{
              height: "400px",
              overflow: "hidden",
            }}
            extra={
              collection.is_public ? (
                <Tag icon={<GlobalOutlined />} color="green">
                  Public
                </Tag>
              ) : (
                <Tag icon={<LockOutlined />} color="red">
                  Private
                </Tag>
              )
            }
          >
            {/* Image Grid */}
            <div
              style={{
                height: "200px",
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "8px",
                overflowY: "auto",
                padding: "8px",
              }}
            >
              <Image.PreviewGroup>
                {collection.images.map((image) => (
                  <CollectionThumbnail key={image.id} image={image} />
                ))}
              </Image.PreviewGroup>
            </div>

            {/* Meta Info */}
            <Divider />
            <Meta
              title={collection?.name || "Untitled Collection"}
              description={
                collection?.description || "No description available"
              }
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Collections;
